// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-select {
  position: relative;
}

.user-select label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
  color: var(--text-secondary, #b0b0b0);
  font-size: 0.9rem;
}

.user-select-trigger {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: var(--bg-input, #2a2a3e);
  border: 1px solid var(--border-color, #3a3a50);
  border-radius: 8px;
  cursor: pointer;
  min-height: 42px;
  transition: border-color 0.2s;
}

.user-select-trigger:hover,
.user-select-trigger.open {
  border-color: var(--accent-color, #7c5cbf);
}

.user-select-value {
  display: flex;
  align-items: center;
  gap: 8px;
}

.user-select-placeholder {
  color: var(--text-muted, #666);
}

.user-select-avatar {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
}

.user-select-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  margin-top: 4px;
  background: var(--bg-card, #1e1e2e);
  border: 1px solid var(--border-color, #3a3a50);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  z-index: 100;
  overflow: hidden;
}

.user-select-search {
  width: 100%;
  padding: 10px 12px;
  border: none;
  border-bottom: 1px solid var(--border-color, #3a3a50);
  background: transparent;
  color: var(--text-primary, #fff);
  font-size: 0.9rem;
  outline: none;
  box-sizing: border-box;
}

.user-select-list {
  max-height: 200px;
  overflow-y: auto;
}

.user-select-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  transition: background 0.15s;
}

.user-select-item:hover {
  background: var(--bg-hover, #2a2a3e);
}

.user-select-item.selected {
  background: var(--accent-color-alpha, rgba(124, 92, 191, 0.2));
}

.user-select-info {
  display: flex;
  flex-direction: column;
}

.user-select-displayname {
  font-size: 0.9rem;
  color: var(--text-primary, #fff);
}

.user-select-username {
  font-size: 0.75rem;
  color: var(--text-muted, #666);
}

.user-select-empty {
  padding: 16px;
  text-align: center;
  color: var(--text-muted, #666);
}
`, "",{"version":3,"sources":["webpack://./src/styles/UserSelect.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,8CAA8C;EAC9C,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,eAAe;EACf,mCAAmC;EACnC,8CAA8C;EAC9C,kBAAkB;EAClB,yCAAyC;EACzC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,qDAAqD;EACrD,uBAAuB;EACvB,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC","sourcesContent":[".user-select {\n  position: relative;\n}\n\n.user-select label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n  color: var(--text-secondary, #b0b0b0);\n  font-size: 0.9rem;\n}\n\n.user-select-trigger {\n  display: flex;\n  align-items: center;\n  padding: 10px 12px;\n  background: var(--bg-input, #2a2a3e);\n  border: 1px solid var(--border-color, #3a3a50);\n  border-radius: 8px;\n  cursor: pointer;\n  min-height: 42px;\n  transition: border-color 0.2s;\n}\n\n.user-select-trigger:hover,\n.user-select-trigger.open {\n  border-color: var(--accent-color, #7c5cbf);\n}\n\n.user-select-value {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.user-select-placeholder {\n  color: var(--text-muted, #666);\n}\n\n.user-select-avatar {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.user-select-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  margin-top: 4px;\n  background: var(--bg-card, #1e1e2e);\n  border: 1px solid var(--border-color, #3a3a50);\n  border-radius: 8px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  z-index: 100;\n  overflow: hidden;\n}\n\n.user-select-search {\n  width: 100%;\n  padding: 10px 12px;\n  border: none;\n  border-bottom: 1px solid var(--border-color, #3a3a50);\n  background: transparent;\n  color: var(--text-primary, #fff);\n  font-size: 0.9rem;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.user-select-list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.user-select-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 12px;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n\n.user-select-item:hover {\n  background: var(--bg-hover, #2a2a3e);\n}\n\n.user-select-item.selected {\n  background: var(--accent-color-alpha, rgba(124, 92, 191, 0.2));\n}\n\n.user-select-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.user-select-displayname {\n  font-size: 0.9rem;\n  color: var(--text-primary, #fff);\n}\n\n.user-select-username {\n  font-size: 0.75rem;\n  color: var(--text-muted, #666);\n}\n\n.user-select-empty {\n  padding: 16px;\n  text-align: center;\n  color: var(--text-muted, #666);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
